import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import ClaimApiService from "../../../../adapters/xhr/ClaimApiService";
import { getConfirmation } from "../../../../components/my-confirmation-dialog/MyConfirmationDialog";
import { MyTextField } from "../../../../components/my-text-field/MyTextField";
import { MyDropdown } from "../../../../components/my-dropdown/MyDropdown";
import MyContext from "../../../../contexts/MyContext";
import { TrainTheme } from "../../../../infrastructure/TrainThemeProvider";
import { FormWrapper } from "../../FormWrapper";
import { Typography, Box, InputLabel } from "@mui/material";
import { TicketType } from "../../../../Constant";

export const TicketForm1New = (props) => {
    const { t } = useTranslation();
    const myContext = useContext(MyContext);
    const [biljettnummerValueErr, setBiljettnummerValueErr] = useState("");
    const [ticketTypeOptionErr, setTicketTypeOptionErr] = useState(null);
    const [ticketTypeOption, setTicketTypeOption] = useState(null);

    const validate = async () => {
        if (ticketTypeOption === null) {
            setTicketTypeOptionErr("required")
            return false;
        }
        if (ticketTypeOption.required) {

            if (!myContext.biljettnummerValue.trim()) {
                setBiljettnummerValueErr("required");
                return false;
            }
            if (ticketTypeOption.regexp !== null) {

                let exp = new RegExp(ticketTypeOption.regexp)

                if (!exp.test(myContext.biljettnummerValue)) {
                    setBiljettnummerValueErr("wrong_format");
                    return false;
                }
            }
        }


        if (myContext.biljettnummerValue.trim()) {

            if (ticketTypeOption.regexp !== null) {
                let exp = new RegExp(ticketTypeOption.regexp)

                if (!exp.test(myContext.biljettnummerValue)) {
                    setBiljettnummerValueErr("wrong_format");
                    return false;
                }
            }

            var ticket = await getTicketInfoAsync();
            myContext.changeTicketInfo(ticket);
            if (ticket) {
                if (ticket.maxReimbursementOverTicketPrice) {
                    const confirmed = await getConfirmation({
                        title: t("info"),
                        message: t("max_reimbursement_over_ticket_price"),
                        theme: TrainTheme,
                    });
                    if (confirmed) { }
                }
            }
        }

        setBiljettnummerValueErr("");
        myContext.changeActiveSlide((myContext.activeSlide += 1));
    }

    const getTicketInfoAsync = async () => {
        let result = await ClaimApiService.getTicketById(myContext.biljettnummerValue.trim(), myContext.ticketType);
        if (result?.isSuccess && result?.data) return result.data;
        else return null;
    };


    const ticketSelectOptions = [
        { biljetttyp: t("Movingo_via_Mälardalstrafik"), format: "BXXXXXXXX", helperText: "format-help-text-movingoticket", regexp: /^B.{8}$/, required: true, ticketType: TicketType.COMMUTER },
        { biljetttyp: t("Movingo_via_SJ"), format: "BXXXXXXXX", helperText: "format-help-text-movingoticket", regexp: /^B.{8}$/, required: true, ticketType: TicketType.COMMUTER },
        { biljetttyp: t("Enkelbiljett_via_Mälardalstrafik"), format: "", helperText: "", regexp: null, required: false, ticketType: TicketType.SINGLE },
        { biljetttyp: t("Enkelbiljett_via_SJ"), format: "2XXXXXXXXXXX", helperText: "format-help-text-singleticket", regexp: /^2.{11}$/, required: false, ticketType: TicketType.SINGLE },
        { biljetttyp: t("Enkelbiljett_via_annan"), format: "2XXXXXXXXXXX", helperText: "format-help-text-singleticket", regexp: /^2.{11}$/, required: false, ticketType: TicketType.SINGLE }
    ]

    return (
        <MyContext.Consumer>
            {(context) => (
                <React.Fragment>
                    <FormWrapper onContinue={validate} hasBackButton={false}>

                        <Typography style={{ marginTop: "0.5rem", width: "100%" }} component="p"> {t("form_main_subtext")}</Typography>
                        <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="chooseTicketType">{`${t("choose_tickettype")}`}</InputLabel>
                        <MyDropdown noOptionsText={t("no_options")}
                            required={true}
                            disableClearable={true}
                            helperText={t(ticketTypeOptionErr)}
                            onChange={(e, value) => {
                                let option = ticketSelectOptions.find(v => v.biljetttyp === value);
                                setTicketTypeOption(option);
                                setTicketTypeOptionErr("")
                                setBiljettnummerValueErr("");
                                context.changeTicketType(option.ticketType);
                            }}
                            label={t("choose_tickettype")}
                            value={ticketTypeOption?.biljetttyp ?? null}
                            options={ticketSelectOptions.map(v => v.biljetttyp)}
                        />
                        {ticketTypeOption !== null &&
                            <Box style={{ marginTop: "0.5rem", width: "100%" }}>
                                <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="ticketNumber">{`${t("ticket_number")}`}</InputLabel>
                                <MyTextField
                                    autoComplete="on"
                                    helperText={t(biljettnummerValueErr)}
                                    placeholder={ticketTypeOption.format}
                                    value={context.biljettnummerValue}
                                    required={ticketTypeOption.required}
                                    label={t("ticket_number")}
                                    inputLabelStyles={{ shrink: true }}
                                    sx={{
                                        '& input::placeholder': {
                                            opacity: 0.42,
                                        }
                                    }}
                                    onChange={context.changeBiljettnummerValue}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter") {
                                            validate();
                                        }
                                    }}
                                    maxLength={100}
                                />
                                <Typography style={{ width: "100%" }} variant="body2">{t(ticketTypeOption.helperText)}</Typography>
                            </Box>
                        }
                    </FormWrapper>
                </React.Fragment>
            )}
        </MyContext.Consumer>
    );
};
